import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';
const json = require("json!./../../../resources/properties.json");

@Injectable()
export class ForumService {
    
    private token: string;
    private _forumURL = "/forumData";    
    private _mainUrl = "/mainData";  
    private serverURL: string; 
    
    constructor(private http: Http) { 
        this.getTokenService();      
        this.serverURL = json.api_url;      
    }    
    
    getTokenService() {
        this.token = localStorage.getItem('token');
    }

    getUserStatus(): Promise<any> {
        
        let token = localStorage.getItem('token');
        let authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return "guest";
                } else {
                    return JSON.parse(res.text());
                }
            }).catch(this.handleError);
        } else {
            return Promise.resolve({role:"guest"});            
        }

    }

    getUserName() {        
        return localStorage.getItem("userName");
    }

    getUnreadMessages() {
        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token != null && token != "") {
            
            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            
            return this.http.get(this.serverURL + this._mainUrl + "/messages", options).toPromise().then(res => {
          
                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text()).rows;
                } else {
                    return null;
                }
            
            }).catch(this.handleError);
        
        } else {            
            return new Promise((resolve, reject) => { return "guest";})
        }
    }

    getElementsBySearchFilterValue(searchFilterValue: string) {
        
        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });        
        return this.http.get(this.serverURL + this._mainUrl + "/search/" + searchFilterValue, options).toPromise().then(res => {            
            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }
            
        }).catch(this.handleError);            

    }

    getElementsAuthenticatedBySearchFilterValue(searchFilterValue: string) {        
        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });        
        return this.http.get(this.serverURL + this._mainUrl + "/search/authenticated/" + searchFilterValue, options).toPromise().then(res => {            
            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }
            
        }).catch(this.handleError);            

    }

    login(email: string, password: string) {

        let creds = "email=" + email + "&password=" + password;

        return this.http.post(this.serverURL + '/loginData', creds, { headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded'})}).map((res: any) => {
            let data = res.json();
            if (data.token !== undefined) {
                this.token = data.token;
                localStorage.setItem('token', this.token);
            }
            return data;
        });

    }

    sendEmailRecoverPassword(email: string) {
        
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
        
        return this.http.post(this.serverURL + "/loginData/forgetPassword", this.serializeObj({email: email}), {headers: authHeader}).toPromise().then(result => {
        
            return JSON.parse(result.text()).code;            

        }).catch(this.handleError);

    }

    verifyEmail(email: string) {
        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            
            return this.http.get(this.serverURL + "/usersData/existsEmail/" + email, options).toPromise().then(res => {
          
                if (JSON.parse(res.text()).code == 1) {
                    return true;
                } else {
                    return false;
                }
            
            }).catch(this.handleError);
                
        
    }

    getTitle() {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });  

        return this.http.get(this.serverURL + this._forumURL + "/title", options).toPromise().then(res => {            
            
            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).title;
            } else {
                return null;
            }
            
        }).catch(this.handleError);

    }

    getTopics() {
        
        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });  

        return this.http.get(this.serverURL + this._forumURL + "/topics", options).toPromise().then(res => {            
            
            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }
            
        }).catch(this.handleError);            

    }    

    getTopicById(topic_id: number) {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });  

        return this.http.get(this.serverURL + this._forumURL + "/topic/" + topic_id, options).toPromise().then(res => {

            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).row;
            } else {
                return null;
            }

        }).catch(this.handleError);

    } 

    getForumMessagesByTopicId(topic_id: number) {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });  

        return this.http.get(this.serverURL + this._forumURL + "/messages/" + topic_id, options).toPromise().then(res => {

            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }

        }).catch(this.handleError);

    }

    getMessageById(message_id: number) {
        let token = localStorage.getItem('token');
        let authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});                
            
        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });  

        return this.http.get(this.serverURL + this._forumURL + "/message/" + message_id, options).toPromise().then(res => {

            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).row;
            } else {
                return null;
            }

        }).catch(this.handleError);
    }

    postTopic(topic_name: string) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }

        return this.http.post(this.serverURL + this._forumURL + "/topic", this.serializeObj({topicName: topic_name}), {headers: authHeader}).toPromise().then(result => {
            
            return JSON.parse(result.text());

        }).catch(this.handleError);

    }

    postMessage(message_content: string, topic_id: number, message_parent_id: number) {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }

        return this.http.post(this.serverURL + this._forumURL + "/message", this.serializeObj({messageContent: message_content, topicId: topic_id, messageParentId: message_parent_id}), {headers: authHeader}).toPromise().then(result => {
            
            return JSON.parse(result.text());

        }).catch(this.handleError);

    }

    private handleError(error: any) {        
        let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    private serializeObj(obj: any) {
        var result: any[] = [];
        for (var property in obj) {
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
        }            
        return result.join("&");
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/forum/forum.service.ts
 **/